export default __webpack_public_path__ + "static/media/hus.6865703e.png";